export default {
  home: {
    hello: "¡Hola,",
    description: "Este es tu panel de control de hoy.",
    advice: {
      name: "Consejo nº1",
      title: "Guía práctica para la sostenibilidad financiera de las ONG",
      description: "La primera parte del texto es una conceptualización.",
      more: "Ver más"
    },
    tools: {
      title: "Tus herramientas",
      web: "Diseña tu web",
      shop: "Crea tu tienda",
      events: "Crear evento",
      blog: "Crear tu blog",
      reviews: "Reseñas",
      bookings: "Reservas",
      projects: "Crear portafolio",
      services: "Crear servicios"
    },
    ybs: "Con el apoyo de"
  }
};
